import styled from 'styled-components';
import { FontSizeProps, fontSize } from 'styled-system';
import { Flex, themeGet } from '@packages/ui';

export const StyledCenteredFlex = styled(Flex)`
  justify-content: center;
`;

export const StyledCTAWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: ${themeGet.space(1)};
  padding-top: ${themeGet.space(2)};
`;

export const StyledTextRow = styled(StyledCenteredFlex)<FontSizeProps & { color: string }>`
  ${fontSize}
  text-align: center;
  color: ${(props) => props.color}};
`;

export const StyledTitle = styled(StyledTextRow)`
  font-family: ${themeGet.fonts('brandSecondary')};
  font-weight: ${themeGet.fontWeight('semibold')};
`;

export const StyledSubitle = styled(StyledTextRow)`
  font-family: ${themeGet.fonts('brand')};
  font-weight: ${themeGet.fontWeight('lighter')};
  padding-top: ${themeGet.space(1)};
`;

export const StyledInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  width: 100%;
  min-width: 100%;
  height: 100%;
  min-height: 100%;
`;
